var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 232 100",
    style: {
      enableBackground: "new 0 0 232 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFAF5F;}\r\n\t.st1{fill:#FF9B47;}\r\n\t.st2{fill:#FFDEBF;}\r\n\t.st3{fill:#FF8C2F;}\r\n\t.st4{fill:#E3C6AC;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "8,63.6 24.7,58 20.6,71.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M226.2,36.4L55.7,54.2L9.7,25l-3.9-2.5L176.5,4.8l49.6,31.4l0,0C226.1,36.2,226.2,36.3,226.2,36.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M227.1,75.4l0,0.2L56.3,93.4L56,93.3l0.1-0.2c3-6.2,4.9-13,4.9-19.8c0-6.7-1.8-13.5-5.6-19.1l0.3,0l170.5-17.8 c3.9,5.6,5.7,12.4,5.7,19.2C231.9,62.4,230.1,69.2,227.1,75.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61,73.3c0,6.9-1.9,13.7-4.9,19.8L56,93.3L10.2,65.1l0.1-0.1c3-6.2,4.9-13,4.9-19.8c0-6.9-1.4-14.5-5.4-20.1 l0,0l46,29.1l-0.3,0C59.2,59.8,61,66.5,61,73.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M55.7,94.2c-0.2,0-0.3,0-0.5-0.1L7.5,64.4c-0.4-0.3-0.6-0.9-0.3-1.3c0.3-0.4,0.9-0.6,1.3-0.3l47.8,29.7 c0.4,0.3,0.6,0.9,0.3,1.3C56.4,94.1,56,94.2,55.7,94.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M55.2,54.8c-0.2,0-0.3,0-0.5-0.1l-49-30.5c-0.4-0.3-0.6-0.9-0.3-1.3c0.3-0.4,0.9-0.6,1.3-0.3l49,30.5 c0.4,0.3,0.6,0.9,0.3,1.3C55.8,54.6,55.5,54.8,55.2,54.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M200.7,72.1l0,0.1l-117,12.1c0,0,3.5-4.5,3.2-13.2c-0.4-10.2-3.4-13.6-3.6-13.6l116.9-12.2 c2.7,3.8,3.9,8.5,3.9,13.1C204.1,63.2,202.8,67.9,200.7,72.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.5,72c0,2.5-1.6,4.5-3.7,4.5c-2,0-3.7-2-3.7-4.5c0-2.5,1.6-4.5,3.7-4.5C76.8,67.5,78.5,69.5,78.5,72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M218.6,58c0,2.5-1.6,4.5-3.7,4.5c-2,0-3.7-2-3.7-4.5c0-2.5,1.6-4.5,3.7-4.5C217,53.5,218.6,55.5,218.6,58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M58,88c-11.9-6.9-23.8-13.9-35.6-20.8c-3.3-2-6.7-3.9-10-5.9c-0.5-0.3-1,0.5-0.4,0.8 C23.8,69.1,35.7,76.1,47.5,83c3.3,2,6.7,3.9,10,5.9C58.1,89.2,58.5,88.3,58,88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M59.7,82.9c-6-3.1-11.8-6.6-17.6-10c-6-3.6-11.9-7.1-17.9-10.7c-3.4-2-6.7-4-10.1-6c-0.5-0.3-1,0.5-0.4,0.8 c11.9,7.1,23.7,14.3,35.6,21.2c3.3,1.9,6.6,3.8,10,5.5C59.8,84,60.2,83.2,59.7,82.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M60.2,77.7c-11.3-7.2-22.7-14.3-34-21.5c-3.2-2-6.4-4.1-9.7-6.1c-0.5-0.3-1,0.5-0.4,0.8 c11.3,7.2,22.7,14.3,34,21.5c3.2,2,6.4,4.1,9.7,6.1C60.3,78.9,60.7,78,60.2,77.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M59.8,69.9c-11.2-7-22.5-13.8-34-20.3c-3.2-1.9-6.5-3.7-9.7-5.5c-0.5-0.3-1,0.5-0.4,0.8 c11.5,6.4,22.9,13.1,34.2,20c3.2,1.9,6.4,3.9,9.5,5.9C59.9,71.1,60.3,70.2,59.8,69.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M58.1,60.3c-10.7-5.5-21.5-10.9-32.2-16.4c-3-1.5-6.1-3.1-9.1-4.6c-0.5-0.3-1,0.6-0.4,0.8l32.2,16.4l9.1,4.6 C58.2,61.4,58.6,60.6,58.1,60.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M43.9,49.7c-7.5-4.3-15-8.6-22.4-12.9c-2.1-1.2-4.3-2.4-6.4-3.7c-0.5-0.3-1,0.5-0.4,0.8 c7.5,4.3,15,8.6,22.4,12.9c2.1,1.2,4.3,2.4,6.4,3.7C43.9,50.8,44.4,50,43.9,49.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M60.1,66.4c-8-4.5-16.1-9-24.1-13.5c-2.3-1.3-4.5-2.5-6.8-3.8c-0.5-0.3-1,0.5-0.4,0.8c8,4.5,16.1,9,24.1,13.5 c2.3,1.3,4.5,2.5,6.8,3.8C60.2,67.5,60.6,66.7,60.1,66.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M37.1,66.6c-7.1-4.5-14.2-9-21.3-13.4c-0.5-0.3-1,0.5-0.4,0.8c7.1,4.5,14.2,9,21.3,13.4 C37.2,67.8,37.6,66.9,37.1,66.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.37d820b4cc67fc0b1769881a9d06da52.svg";
export { ForwardRef as ReactComponent };